import script from "./SignupWrapper.vue?vue&type=script&setup=true&lang=ts"
export * from "./SignupWrapper.vue?vue&type=script&setup=true&lang=ts"

import "./SignupWrapper.vue?vue&type=style&index=0&id=c0179da8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c0179da8"]])

export default __exports__